import { get } from 'lodash-es';
export function getValue<T = unknown, R = unknown>(
  target: T,
  getter: string | ((item: T) => R),
): R | undefined {
  if (typeof getter === 'function') {
    return getter(target);
  }
  if (typeof getter === 'string') {
    return get(target, getter);
  }
  return undefined;
}
